import React from 'react';
import { useCms } from '../cms/CmsContext';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import './MapsDirections.css';
import { getCmsImagePath } from '../cms/cmsData';
import { getArabicTranslation } from '../utils/arabicTranslations';

const MapsDirections = () => {
  const { content } = useCms();
  const cms = content?.mapsDirectionsPage || {};

  return (
    <div className="page-wrapper">
      <AnnouncementBar />
      
      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        <TornPaperWrapper>
          <h1 className="card-title">{cms.title} <span className="arabic-text on-white">{getArabicTranslation('Map & Directions')}</span></h1>
          <div className="card-content">
            <p className="card-description info-placeholder">
              More information will be announced soon. Please visit the OC Fair & Events Center page using this link:{' '}
              <a href="https://ocfair.com/about-us/maps-directions/" target="_blank" rel="noopener noreferrer" style={{ color: '#D42533', textDecoration: 'underline' }}>
                ocfair.com/about-us/maps-directions/
              </a>{' '}
              for the maps and directions page.
            </p>
          </div>
        </TornPaperWrapper>

        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath("lanterns", "/lanterns.webp")} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      <SponsorsSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default MapsDirections;
